import styled, { css } from 'styled-components';
import { breakpoint } from '../../theme/breakpoint';

export const Wrapper = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.large};
  ${({ $borderTop }) =>
    $borderTop &&
    css`
      margin-top: ${({ theme }) => theme.spacing.medium};
      border-top: 1px solid ${({ theme }) => theme.palette.border};
      padding-top: ${({ theme }) => theme.spacing.standard};
    `};

  ${breakpoint.desktop`
    margin-right: -20px;
  }
    `}
`;

export const List = styled.ul`
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${breakpoint.desktop`
  justify-content: flex-start;
  
  li {
  margin-right: ${({ theme }) => theme.spacing.standard};
}
  `}
`;
